import { defineStore } from 'pinia';

// Monotonic id — never reused, so :key stays stable even if the list empties
// and refills within the same tick.
let nextId = 0;

// Matches the old vue-toastification maxToasts cap.
const MAX_TOASTS = 3;

// Default lifetime (ms) per toast type. Error lives longest; a persistent
// error passes duration 0 to opt out of auto-dismiss entirely.
export const TOAST_DURATIONS = {
    success: 3000,
    info: 5000,
    warning: 5000,
    error: 10000
};

export const useToastStore = defineStore('toast', {
    state: () => ({
        toasts: []
    }),

    actions: {
        // Pushes a toast and returns its id (so callers can dismiss it early).
        // Newest goes on top so the freshest message is closest to the corner.
        Add({ type, message, title = null, duration, persistent = false, errorId = null }) {
            const id = ++nextId;
            const resolvedDuration = persistent
                ? 0
                : (duration ?? TOAST_DURATIONS[type] ?? TOAST_DURATIONS.info);

            this.toasts.unshift({
                id,
                type,
                message,
                title,
                duration: resolvedDuration,
                // Correlation id for an uncontrolled error. When present the
                // toast shows a "Ref:" line with a copy button.
                errorId
            });

            if (this.toasts.length > MAX_TOASTS) {
                this.toasts.length = MAX_TOASTS;
            }

            return id;
        },

        Dismiss(id) {
            const index = this.toasts.findIndex(t => t.id === id);
            if (index !== -1) {
                this.toasts.splice(index, 1);
            }
        },

        Clear() {
            this.toasts = [];
        }
    }
});
